// extracted by mini-css-extract-plugin
export default {"roster":"Roster_roster__bXbwg","listWrpr":"Roster_listWrpr__07irR","listItem":"Roster_listItem__hRMnY","icon":"Roster_icon__6v49w"};